export const enum SocialUrl {
  Twitter = "https://twitter.com/",
  Discord = "https://discord.com/",
  Telegram = "https://t.me/",
}
